import { toast } from 'react-toastify';
import { compose, over, lensProp, omit } from 'ramda';

import {
  fetchProfile,
  createNewUser,
  updateUser,
  requestUpdateUserPassword,
  requestResetUserPassword,
  consultNewPasswordTerms,
  consultUserNewPasswordTerms,
  fetchMfa,
  updateEnableMfa,
  updateDisableMfa,
  updateEnableMfaConfirm,
  updateDisableMfaConfirm
} from './service';

import {
  setUserId,
  setUser,
  setUserMfa,
  handleLoading,
  setUserRestrictions,
  setUserOwnTerms,
  setUserTermsNotAccepted
} from './actions';

import { updateToken, setUuid } from '../../Login/store/actions';
import { setToken } from '../../../services';

import { formatToOnlyNumbers } from '../../../helpers/formatters';

export const loadProfile = userId => dispatch => {
  dispatch(handleLoading(true));

  return fetchProfile(userId)
    .then(({ data }) => {
      const { userRestrictions, profileId } = data;

      dispatch(setUser(data));
      dispatch(setUserRestrictions(userRestrictions, profileId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertUser = params => dispatch => {
  const formatParams = compose(
    over(lensProp('phone'), formatToOnlyNumbers),
    omit(['establishmentId', 'termsOfUse'])
  );

  dispatch(handleLoading(true));

  if (!formatParams(params).userId) {
    delete params['userId'];

    return createNewUser(formatParams(params))
      .then(({ data }) => {
        const { userId, accessToken, uuid } = data;

        setToken(accessToken);

        dispatch(setUuid(uuid));
        dispatch(updateToken(accessToken));
        dispatch(setUserId(userId));

        toast.success('Usuário criado com sucesso!');

        return Promise.resolve();
      })
      .catch(() => {
        return Promise.reject();
      })
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateUser(formatParams(params))
    .then(({ data }) => {
      toast.success('Usuário atualizado com sucesso!');
      dispatch(setUser(data));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const updateUserPassword = (userId, params) => dispatch => {
  dispatch(handleLoading(true));

  return requestUpdateUserPassword(userId, params)
    .then(() => {
      toast.success('Senha atualizada com sucesso!');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const resetUserPassword = (userId, params) => dispatch => {
  return requestResetUserPassword(userId, params)
    .then(() => {
      toast.success('Senha atualizada com sucesso!');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadNewPasswordTerms = userId => dispatch => {
  return consultNewPasswordTerms(userId)
    .then(({ data }) => {
      dispatch(setUserOwnTerms(data));
      return Promise.resolve(data || []);
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const loadUserNewPasswordTerms = userId => dispatch => {
  dispatch(handleLoading(true));

  return consultUserNewPasswordTerms(userId)
    .then(({ data }) => {
      dispatch(setUserTermsNotAccepted(data));
      return Promise.resolve(data || []);
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadMfa = userId => dispatch => {
  dispatch(handleLoading(true));

  return fetchMfa(userId)
    .then(({ data }) => dispatch(setUserMfa(data)))
    .finally(() => dispatch(handleLoading(false)));
}

export const enableMfa = userId => dispatch => {
  dispatch(handleLoading(true));

  return updateEnableMfa(userId)
    .then(({ data }) => {
      toast.success(data?.message);
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const disableMfa = userId => dispatch => {
  dispatch(handleLoading(true));

  return updateDisableMfa(userId)
    .then(({ data }) => {
      toast.success(data?.message);
            return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const enableMfaConfirm = (userId, code) => dispatch => {
  dispatch(handleLoading(true));

  return updateEnableMfaConfirm(userId, code)
    .then(({ data }) => {
      toast.success(data?.message);
      dispatch(loadMfa(userId));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const disableMfaConfirm = (userId, code) => dispatch => {
  dispatch(handleLoading(true));

  return updateDisableMfaConfirm(userId, code)
    .then(({ data }) => {
      toast.success(data?.message);
      dispatch(loadMfa(userId));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}